import {intAbbreviation} from '../../common/util';

export function ShareCount(props: jsx.Props, context: jsx.AppGlobals) {
    const gettextSubComponent = context.gtService.gettextSubComponent;
    const count = props.gif.shares || 0;
    const countStr = <strong>{intAbbreviation(count)}</strong>;
    return <div className="ShareCount">
        {count === 1 ?
            gettextSubComponent('{countStr} share', {countStr}) :
            gettextSubComponent('{countStr} shares', {countStr})}
    </div>;
}
